import React from 'react';
import { motion } from 'framer-motion';
const rows = [{
  sin: '6 hs de estudio × 3 parciales por cuatrimestre',
  costo: '18 horas perdidas que no recuperás'
}, {
  sin: 'TPs sin estructura',
  costo: 'Noches enteras bloqueado/a'
}, {
  sin: 'Estudiar sin simulacro previo',
  costo: 'Parciales que podrían ir mejor'
}, {
  sin: 'Sin plan de estudio',
  costo: 'Pánico cada vez que se acerca un final'
}, {
  sin: 'Mismo método, mismo resultado',
  costo: 'Otro cuatrimestre igual que el anterior'
}];
export function CostoNoActuar() {
  return <section className="bg-[#0C1220] py-[60px] md:py-[80px]" data-id="element-66">
      <div className="max-w-[800px] mx-auto px-5" data-id="element-67">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(28px,5vw,42px)] font-black text-center leading-[1.2] mb-10" data-id="element-68">
          ⚖️ ¿Cuánto cuesta NO tenerlo?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="hidden md:block bg-navy-2 border border-[#FF5F57]/30 rounded-xl overflow-hidden mb-8" data-id="element-69">
          <div className="grid grid-cols-2 bg-navy-3 border-b border-[#FF5F57]/30" data-id="element-70">
            <div className="p-5 font-bold text-brand-gray text-[13px] uppercase tracking-[1px]" data-id="element-71">
              Sin sistema
            </div>
            <div className="p-5 font-bold text-[#FF5F57] text-[13px] uppercase tracking-[1px] border-l border-[#FF5F57]/30 bg-[#FF5F57]/5" data-id="element-72">
              Costo real
            </div>
          </div>
          {rows.map((row, i) => <div key={i} className="grid grid-cols-2 border-b border-brand-blue-dark/50 last:border-0" data-id="element-73">
              <div className="p-5 text-[15px] text-brand-gray flex items-center" data-id="element-74">
                {row.sin}
              </div>
              <div className="p-5 text-[15px] font-bold text-white border-l border-[#FF5F57]/30 bg-[#FF5F57]/5 flex items-center" data-id="element-75">
                {row.costo}
              </div>
            </div>)}
        </motion.div>

        <div className="md:hidden flex flex-col gap-4 mb-8" data-id="element-76">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-2 border border-[#FF5F57]/30 rounded-xl overflow-hidden" data-id="element-77">
              <div className="p-4 border-b border-[#FF5F57]/30 text-[14px] text-brand-gray text-center" data-id="element-78">
                <span className="block text-[11px] font-bold uppercase tracking-[1px] mb-1" data-id="element-79">
                  Sin sistema
                </span>
                {row.sin}
              </div>
              <div className="p-4 bg-[#FF5F57]/5 flex flex-col items-center text-center gap-1" data-id="element-80">
                <span className="text-[11px] font-bold text-[#FF5F57] uppercase tracking-[1px]" data-id="element-81">
                  Costo real
                </span>
                <span className="text-[15px] font-bold text-white" data-id="element-82">
                  {row.costo}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center text-[clamp(18px,3vw,22px)] font-black text-brand-gold leading-[1.4]" data-id="element-83">
          El próximo parcial puede ser diferente.
        </motion.p>
      </div>
    </section>;
}